import { mopGeneric } from '../constants/PaymentTypes';
export var ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["SERVER"] = "server";
  ErrorType["AUTHORIZATION"] = "auth";
  ErrorType["INLINE"] = "inline";
  return ErrorType;
}({});
export var InlineErrors = /*#__PURE__*/function (InlineErrors) {
  InlineErrors["REQUIRED"] = "required";
  InlineErrors["INVALID"] = "invalid";
  return InlineErrors;
}({});
export var ERRORS = {
  UNSUPPORTED_COMMAND: {
    code: 'PM-001',
    message: 'Unsupported Command',
    type: ErrorType.SERVER
  },
  BRAINTREE_TOKENIZATION_FAILURE: {
    code: 'PM-002',
    message: 'Braintree Tokenization Failure',
    type: ErrorType.SERVER
  },
  INLINE_ERRORS: {
    code: 'PM-003',
    message: 'Please complete all required fields.',
    type: ErrorType.INLINE
  },
  NO_SELECTED_MOP: {
    code: 'PM-004',
    message: 'No selected mop. Perhaps the component is not initialized yet.',
    type: ErrorType.SERVER
  },
  MISSING_ADDRESS_INFORMATION: {
    code: 'PM-005',
    message: 'Missing address information',
    type: ErrorType.INLINE
  },
  RECURLY_TOKENIZATION_FAILURE: {
    code: 'PM-006',
    message: 'Recurly Tokenization Failure',
    type: ErrorType.SERVER
  },
  NO_SUPPORTED_PAYMENT_METHODS: {
    code: 'PM-007',
    message: 'Sorry, we cannot currently process payments from your country.',
    type: ErrorType.SERVER
  },
  INVALID_ZIPCODE: {
    code: 'PM-008',
    message: 'Please add a valid zip/postal code or a new payment method.',
    type: ErrorType.SERVER
  },
  UPI_ERROR: {
    code: 'PM-009',
    message: 'Something went wrong. Please try again later or',
    type: ErrorType.SERVER
  },
  MISSING_PAYMENT_DETAILS_ERROR: {
    code: 'PM-010',
    message: 'No nonce or billing contact',
    type: ErrorType.SERVER
  },
  PAYMENT_PROCESSING_ERROR: {
    code: 'PM-011',
    message: mopGeneric.message_detail,
    type: ErrorType.SERVER
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/constants/Errors.js
// module id = 111
// module chunks = 11